import { type ComponentForm } from '../component-types.js';

/** `shadowCaster2d`: blocks 2D lights with shadows (see engine/docs/systems/lighting-2d.md). */
const shadowCaster2d: ComponentForm = {
  key: 'shadowCaster2d',
  label: '2D Shadow Caster',
  icon: 'light',
  order: 33,
  defaults: { source: 'sprite' },
  fields: [
    { key: 'source', label: 'Source', type: { kind: 'enum', options: ['sprite', 'collider', 'tilemap', 'polygon'] }, read: (v) => v.source ?? 'sprite' },
    { key: 'polygon', label: 'Polygon', type: { kind: 'json' }, hint: '[[x, y], ...] in entity space.', showIf: (v) => v.source === 'polygon', read: (v) => v.polygon ?? [] },
    { key: 'selfShadow', label: 'Self Shadow', type: { kind: 'bool' }, read: (v) => v.selfShadow ?? false },
    { key: 'enabled', label: 'Enabled', type: { kind: 'bool' }, read: (v) => v.enabled ?? true },
  ],
};
export default shadowCaster2d;
